module.exports = __webpack_public_path__ + "img/building-icon-demand.75e8014a.png";